module.exports = __webpack_public_path__ + "static/media/VTR@2x.a1b9ff30.png";